import { useSearch } from "@tanstack/react-router";
import { useGetIncomingPostbackQuery } from "api/TenantSlug/IncomingPostback/hooks.ts";
import { ModifyPostbackIncomingMethodsForm } from "components/Forms/ModifyPostbackIncomingMethodsForm/ModifyPostbackIncomingMethodsForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface SearchParams {
    [`modifyPostbackIncomingMethods-id`]: string;
}

export const ModifyPostbackIncomingMethodsDrawer: FC = () => {
    const drawerId = DrawerId.ModifyPostbackIncomingMethods;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const incomingPostbackId = searchParams[`${drawerId}-id`];
    const getIncomingPostbackQuery = useGetIncomingPostbackQuery(incomingPostbackId, {});

    if (
        getIncomingPostbackQuery.isLoading ||
        getIncomingPostbackQuery.isFetching ||
        !getIncomingPostbackQuery.data?.incomingPostback
    ) {
        return <></>;
    }

    const incomingPostback = getIncomingPostbackQuery.data.incomingPostback;

    return (
        <Drawer drawerId={drawerId} title={<DrawerTitle mainTitle={"Metody"} subTitles={[incomingPostback.name]} />}>
            <ModifyPostbackIncomingMethodsForm
                onClose={() => drawerUtils.hide(drawerId)}
                incomingPostback={incomingPostback}
            />
        </Drawer>
    );
};
